import React from 'react';
import { connect } from 'react-redux';
import CheckAndRequest from '~/src/components/CheckAndRequest';
import { Wrapper, Check, Image, Container } from './styled';

const CheckList = ({ checkList, textBottomForm = null }) => {
    return (
        <Wrapper  id='request_form'>
            <Container>
                <Check>
                    <CheckAndRequest
                        idForm='request_form'
                        checkList={{ total: 0, data: checkList }}
                        backgroundColor='transparent'
                        maxWidth='863px'
                        textBottomForm={textBottomForm}
                    />
                </Check>
                <Image>
                    <img src='/static/images/mono-village/gpon.png'/>
                </Image>
            </Container>
        </Wrapper>
    );
};

const  mapStateToProps = state => ({
    checkList: state.villageDetail.checkList
});

export default connect(mapStateToProps)(CheckList);
